import { render, staticRenderFns } from "./InterestCreate.vue?vue&type=template&id=331ffe30&"
import script from "./InterestCreate.vue?vue&type=script&lang=js&"
export * from "./InterestCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports